<template>
  <div class="comReport">
    <!-- 物业报修,投诉建议 如果是同创项目才显示 -->
    <div
      class="type_box"
      v-if="(common.hasTsModule ||showRepairSelect==1)&& (common.marketInfo.cityId == 1 || common.marketInfo.cityId == 5||common.marketInfo.cityId == 2 ||common.marketInfo.cityId == 89)"
    >
      <div @click="changeType(1)" :class="['type_box_item',repairSelectType == 1?'cur':'']">
        <img
          :src="repairSelectType == 1?require(`../../assets/images/icon_check_${common.theme}.png`):require('../../assets/images/icon_check_normal.png')"
        />
        <p>物业报修</p>
      </div>
      <div @click="changeType(2)" :class="['type_box_item',repairSelectType == 2?'cur':'']">
        <img
          :src="repairSelectType == 2?require(`../../assets/images/icon_check_${common.theme}.png`):require('../../assets/images/icon_check_normal.png')"
        />
        <p>投诉建议</p>
      </div>
    </div>
    <div>
      <div class="module">
        <inpBox v-if="marketList.length>0"
          title="选择项目"
          inpBoxType="select"
          :border="border"
          @select="selectmarket()"
          :selectValue="localMarkInfo.marketName"
        ></inpBox>
        <inpBox
          :title="repairSelectType == 1?'报修类型':'投诉类型'"
          inpBoxType="select"
          :border="border"
          @select="select('repairType')"
          :selectValue="postInfo.repairType"
        ></inpBox>
        <div class="selectBottom" ref="personWrap" v-if="!postInfo.repairType">
          <div class="selectTab" ref="personTab">
            <template v-if="repairSelectType == 1">
              <div
                class="tag"
                v-for="item in repairTypeData_1"
                :key="item.text"
                @click.prevent="selectRepairType(item)"
              >{{item.text}}</div>
            </template>
            <template v-if="repairSelectType == 2">
              <div
                class="tag"
                v-for="item in repairTypeData_2"
                :key="item.text"
                @click.prevent="selectRepairType(item)"
              >{{item.text}}</div>
            </template>
          </div>
        </div>
        <div class="inpBox">
          <span class="Must">*</span>
          <div class="title">上门时间</div>
          <div class="inpWrap">
            <yd-datetime
              class="inp"
              type="datetime"
              v-model="expectTime"
              slot="right"
              :start-date="currentDate"
              :callback="changeDate"
            ></yd-datetime>
          </div>
          <div>
            <img class="rightIcon" src="../../assets/images/repair/rightIcon.png" alt />
          </div>
        </div>
        <!-- <inpBox
          title="提报地点"
          :showRight="false"
          keyName="address"
          @onInput="onInput"
          @blur="blur"
          :inpval="postInfo.address"
        ></inpBox> -->
        <inpBox
          v-if="common.userTenantInfo.userName&& fangList&& fangList.length>0"
          title="报修房源"
          inpBoxType="select"
          :border="border"
          @select="selectFang('repairType')"
          :selectValue="selectItemArrStr"
        ></inpBox>
      </div>
      <div class="module">
        <inpBox
          title="联系人"
          :showRight="false"
          keyName="promoter"
          @onInput="onInput"
          @blur="blur"
          :inpval="postInfo.promoter"
        ></inpBox>
        <inpBox
          title="联系电话"
          :showRight="false"
          keyName="promoterPhoneNo"
          @onInput="onInput"
          @blur="blur"
          :inpval="postInfo.promoterPhoneNo"
        ></inpBox>
      </div>
      <div class="module">
        <div class="titleOther">
          <span class="Must">*</span>问题描述
        </div>
        <textarea
          class="textarea"
          name="name"
          rows="8"
          cols="80"
          placeholder="请输入不少于3字描述"
          v-model="postInfo.remark"
          @blur="blur"
        ></textarea>
      </div>
      <div class="module">
        <div class="titleOther">
          <span class="Must Mustno">*</span>上传照片
          <span class="titleOther_tips">（选填）</span>
        </div>
        <div class="pic">
          <div class="addPic" v-for="(item,index) in fileList" :key="item.path">
            <!-- <template v-if="item.postfix.indexOf('image') == -1">
          <video class="video" :id="'id'+index" :src="item.path" @click="viewVideo(index)"></video>
          <img class="video_icon" src="../../assets/images/video.png" @click="viewVideo(index)">
            </template>-->
            <img class="video" :src="item.path" @click="viewImage(item.path,index)" />
            <img
              class="deleteFile"
              @click.stop="deleteFile(item)"
              src="../../assets/images/btn_clear.png"
            />
          </div>
          <!-- 上传控件 -->
          <!-- <template v-if="fileList && fileList.length < 9">
        <a-upload ref="upload" id="upload" name="files" accept="image/*" :action="url" :headers="headers" :data="{
            'target': targetId,
            'moduleCode': 'FX',
            'platform': 'SaasMobile',
            'timestamp': timemap,
            'sign':hex_md5_return,
            'companyId':common.userInfo.cityId
          }" listType="picture-card" :showUploadList="false" :beforeUpload="beforeUpload"
          @preview="handlePreview" @change="handleChangeVideo" :remove="remove" :multiple="true" style="display:inline-block;background:#fff;border-radius:8px;display:flex;align-items:center;">
          <div class="addPic" @click="getInp">
            <a-icon type="plus" class="add_icon"/>
          </div>
        </a-upload>
          </template>-->
          <!--  -->
          <div class="addPic">
            <img class="addImg" src="../../assets/images/repair/add.png" alt />
            <input
              class="file"
              name="files"
              type="file"
              id="fileInput"
              :multiple="true"
              accept="image/*"
              @change="change"
            />
          </div>
        </div>
        <!-- <p class="tips">* 建议照片数量不超过5张，以保证最佳使用效果。</p> -->
      </div>
      <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
        <mt-picker
          class="picker"
          :slots="dataList"
          @change="onValuesChange"
          :visible-item-count="5"
          :show-toolbar="true"
          ref="picker"
        >
          <div class="picker_wrap">
            <div class="picker_btn" @click="popupVisible=false">取消</div>
            <div class="picker_btn2" @click="handleConfirm">确认</div>
          </div>
        </mt-picker>
      </mt-popup>

      <!-- 选择房源 -->
      <mt-popup
        v-model="popupVisible_fang"
        position="bottom"
        class="mint-popup"
        :closeOnClickModal="false"
      >
        <div class="fang">
          <div class="fang_title">
            <div class="fang_title_1" @click="cancelFang">取消</div>
            <div class="fang_title_2">报修房源</div>
            <div class="fang_title_3" @click="sureFang">确认</div>
          </div>
          <div class="fangCon" ref="fangCon">
            <div
              class="fangCon_item"
              ref="fangCon_item"
              v-for="(item,index) in fangList"
              :key="index"
              @click="selectFangItem(item)"
            >
              <img
                v-if="selectItemList.indexOf(item.spaceId)!=-1"
                class="fangCon_item_1_img"
                src="../../assets/images/repair/icon_check@3x.png"
                alt
              />
              <div v-else class="fangCon_item_1"></div>
              <div class="fangCon_item_2">{{item.buildName}}{{item.floorName}}{{item.storeName}}</div>
            </div>
          </div>
        </div>
      </mt-popup>

      <div class="btnWrap_h"></div>
      <div class="bottomBtn_wrap">
        <div
          :class="['btn',postInfo.repairType!=''&&postInfo.promoter!=''&&postInfo.promoterPhoneNo!=''&&postInfo.remark!=''&&expectTime!=''&&spaceRelBeans.subProjectName!=''?'bottomBtn':'']"
          @click="submit"
        >提交</div>
      </div>
      <!-- 查看大图 -->
      <fade-animation>
        <common-gallary
          :imgs="arrImgs"
          :curIndex="curIndex"
          v-show="showGallary"
          @close="showGallary=false"
        ></common-gallary>
      </fade-animation>
    </div>
  </div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
//    瓦片canvas
var tCanvas = document.createElement('canvas');
var tctx = tCanvas.getContext('2d');

import BScroll from "better-scroll";
import inpBox from '../../components/inpBox';
import util from '../../utils/util';
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import Exif from 'exif-js';
import {
  getIndexStyleByMarketId,
  spaceUpPcHttp,
  getStoreList,
  callSpaceUp
} from '../../utils/api';
import {
  mapState
} from 'vuex';
export default {
  name: 'comReport',
  props: {},
  components: {
    CommonGallary,
    FadeAnimation,
    inpBox
  },
  filters: {
    toDate: function (value) {
      return util.formatTime(new Date(value), 4);
    },
  },
  computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common
    })
  },
  data() {
    return {
      repairSelectType: 1,//1物业报修 2投诉建议
      showRepairSelect:0,
      Orientation: '',
      uploadTimes: 0,////上传的张数
      failTimes: 0,//上传失败的图片
      showPage: false,
      arrImgs: [],
      curIndex: 0,
      showGallary: false,
      marketList:[],
      currentDate:'',
      fangList: [],//房源列表
      selectItemList: [],//选择的房源id数组
      sureSelectItemList: [],//确定  选择的房源id数组
      selectItemArr: [],//选择的房源数组
      selectItemArr_var: [],//确定  选择的房源数组
      selectItemArrStr: '',//选择框展示文本
      selectItemArrStr_var: '',//未确定选择时暂存的 选择框展示文本
      removeSomeUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/removeSomeAttachment',
      searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      changeTargetIdUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/bindSomeAttachments',
      queryFirstRepairType: spaceUpPcHttp + '/property/rstRepair/queryFirstRepairType',//获取一级类型
      timemap: "",
      loading: false,
      url: spaceUpPcHttp + '/syscfg/attachmentTerminal/uploadFile',
      headers: {
        "Access-channel": "saas_rst",
      },
      targetId: new Date().getTime(),
      remove: (res) => {
        this.deleteList.push(res.uid)
      },
      fileList: [],
      fileList_before: [],
      selectType: "", //选择类型
      border: false,
      maxsize: 1000 * 1024,
      popupVisible: false,
      popupVisible_fang: false,
      dataList: [],
      contractList: [],
      videoList: [],
      imgUrlList: [],
      expectTime: "",
      postInfo: {
        dealMethod: "1",//1是派单 2是抢单
        repairFrom: "8", ///报修来源
        repairType: "", //报修名称
        repairTypeId: "", //报修类型id
        // lesseeId: "",
        // lesseeName: "",
        promoter: "",
        promoterPhoneNo: "",
        promoterId: "",
        expectTime: '', //期望上门时间
        rprRepairOrderSpaceRelBeans: [
          // {
          //   subProjectId: '',
          //   subProjectName: '',
          //   projectId: '',
          // }
        ],
        // address: "",
        remark: ""
      },
      spaceRelBeans: {
        subProjectId: '',
        subProjectName: '',
        projectId: '',
      },
      localMarkInfo:'',//本地选中的项目
      markList:'', //可选项目数组 项目
      projectTypeList: [{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
      marketTypeList: [{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
      projectType: [],
      repairTypeList_1: [],
      repairTypeList_11: [],
      repairTypeList_2: [],
      repairTypeList_22: [],
      repairTypeData_1: [],
      repairTypeData_11: [],
      repairTypeData_2: [],
      repairTypeData_22: [],
    };
  },
  created() {
    this.expectTime = util.formatTime(new Date(), 10);
    console.log(this.$route.query)
    setTimeout(() => {
        if(this.common.userId){
           var mlist1 =this.common.marketList; //需求巧合没有cityID 没有marketList
          if(this.$route.query.showRepairSelect){
            this.showRepairSelect = this.$route.query.showRepairSelect;
          //  console.log("marketList ==== " +  JSON.stringify() )
            // var mlist1 =this.common.marketList; //需求巧合没有cityID 没有marketList
            var mlist =[];
            var mnamelist=[];
            for(var i=0;i<mlist1.length;i++){
              var item=mlist1[i];
              for(var j=0;j<item.cityMarkets.length;j++){
                  mlist.push(item.cityMarkets[j]);
                  mnamelist.push(item.cityMarkets[j].marketName)
              }
            }
            this.marketList =mlist;
            if(mlist.length>0){
              this.localMarkInfo =mlist[0];
              for(var n=0;n<mlist.length;n++){
                  if(this.common.marketInfo.id==mlist[n].id){
                    this.localMarkInfo =mlist[n];
                  }
              }
            }
            this.marketTypeList = [{
                  flex: 1,
                  values: mnamelist,
                  className: 'slot1',
                  textAlign: 'center'
                }]
                console.log(this.marketTypeList);
          }
          if (Object.keys(this.common.userTenantInfo).length > 0) {
            this.postInfo.promoter = this.common.userTenantInfo.userName
          } else {
            this.postInfo.promoter = this.common.userInfo.userName
          }

          this.postInfo.promoterPhoneNo = this.common.userInfo.account
          if(mlist1.length>0){
              this.spaceRelBeans.subProjectName = this.localMarkInfo.marketName? this.localMarkInfo.marketName :this.common.marketInfo.marketName
              this.spaceRelBeans.subProjectId = this.localMarkInfo.id ?Number(this.localMarkInfo.id): Number(this.common.marketInfo.id)
              this.spaceRelBeans.projectId = Number(this.common.marketInfo.cityId)
          }else{
              this.spaceRelBeans.subProjectName =this.common.marketInfo.marketName
              this.spaceRelBeans.subProjectId =Number(this.common.marketInfo.id)
              this.spaceRelBeans.projectId = Number(this.common.marketInfo.cityId)
          }
          this.resetSign()
      }else{
        if(this.$route.query.showRepairSelect ==1){
          this.$store.commit('HASTSMODULE', true);
        }
        this.$router.push({
              path:'/login',
              query:{
                Rurl:this.$route.fullPath
              }
            });
          }
     }, 1000);
    this.getIndexStyleByMarketId();
 },
  mounted() {
    this.$nextTick(() => {
      this.personScroll();
    });
    this.getData();
  },
  activated() {
    this.getRepairType();
    this.getSubProjectList();
    this.postInfo.repairType = ""
    this.postInfo.repairTypeId = ""
    // this.postInfo.address = ""
    this.postInfo.remark = ""
  },
  methods: {
    // 判断 是否显示投诉意见按钮
     getIndexStyleByMarketId() {
      getIndexStyleByMarketId({
        marketId: this.$route.query.marketId || this.common.marketInfo.id
      }).then(res => {
        console.log(res);
        if (res.res && res.res.code === 10000 && res.body) {
          let data = res.body;
          // 判断是否有投诉建议模块
          data.menusList.forEach((item) => {
            if (item.id == 11) {
              this.$store.commit('HASTSMODULE', true);
            }
          })
        }
      });
    },
    changeType(val) {
      this.repairSelectType = val;
      this.postInfo.repairType = '';
      this.postInfo.repairTypeId = '';
      this.border = false;
    },
    resetSign() {
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong + si + this.timemap + platfrom
      this.hex_md5_return = this.$md5(str)
      this.currentDate = util.formatTime(new Date(), 10)
    },
    changeDate(date) {
      this.expectTime = date.replace(/-/g, '-');
    },
    getInp() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        let upload = document.querySelector('input')
        upload.click();
        this.resetSign();
      }
    },
    deleteFile(item) {
      let self = this;
      fetch(self.removeSomeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": self.common.userInfo.cityId
        },
        body: JSON.stringify({
          'ids': item.id,
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': self.common.userInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log("替换成功")
        console.log(res)
        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].id == item.id) {
            this.fileList.splice(i, 1)
          }
        }
        this.fileList.forEach((item, i) => {
          if (item.postfix.indexOf('image') > -1) {
            this.$set(this.arrImgs, i, item.path)
          }
        })
      })
    },
    changeTarget(id) {
      let self = this;
      this.resetSign()
      fetch(self.changeTargetIdUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": self.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'newTarget': id,
          'oldTarget': self.targetId,
          'bizCode': 'FX',
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': self.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log("替换成功")
        console.log(res)
      })
    },
    handlePreview(url) {

    },
    beforeUpload(file) {  //没有 还是走上传
      console.log(file)
      this.uploadTimes = this.uploadTimes + 1
      let size = file.size / 1024 / 1024;
      let isLt20M = size < 20;
      if (size >= 20) {
        util.showToast('文件超过20mb', 3000)
        return false;
      }
      if (this.fileList && this.fileList.length > 8) {
        util.hideLoading()
        util.showToast('最多上传9张照片')
        return false;
      }
      return isLt20M;
    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload(image) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)

      // 进行最小压缩0.1
      let compressData = canvas.toDataURL('image/jpeg', 0.1)

      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },
    /* base64转Blob对象 */
    dataURItoBlob(data) {
      let byteString;
      if (data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(data.split(',')[1])
      } else {
        byteString = unescape(data.split(',')[1])
      }
      let mimeString = data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },

    handleChangeVideo(info) {
      util.showLoading("正在上传...");
      if (info.file.status === 'error') {
        this.loading = false
        this.failTimes = this.failTimes + 1
        this.uploadTimes = this.uploadTimes - 1
        if (this.uploadTimes == 0) {
          util.hideLoading()
        }
      } else if (info.file.status === 'uploading') {
        this.loading = true
      } else if (info.file.status === 'done') {
        if (info.file.response.code == 1000) {
          this.imageUrl = info.file.response.data[0].url
          this.loading = false
          this.uploadTimes = this.uploadTimes - 1;
          if (this.uploadTimes == 0) {
            util.hideLoading()
          }
          if (!this.fangList) {
            this.fangList = [];
          }
          this.fileList.push({
            id: info.file.response.data[0].id,
            uid: info.file.uid,
            name: info.file.name,
            status: 'done',
            path: this.imageUrl,
            postfix: info.file.type
          })
          if (this.failTimes > 0) {
            util.showToast('上传失败' + this.failTimes + '张')
            this.failTimes = 0
          }
        } else {
          this.loading = false
          if (info.file.response.msg) {
            util.showToast(info.file.response.msg)
          } else {
            util.showToast('接口返回上传失败')
          }
          util.hideLoading()
        }
      } else {
        this.loading = false
        util.hideLoading()
      }
    },
    blur() {
      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    onInput(event) {
      this.postInfo[event.keyName] = event.val
    },
    viewVideo(index) {
      var video = document.getElementById("id" + index);
      video.play();
    },
    viewImage(url, index) {
      console.log(index)
      this.fileList.forEach((item, i) => {
        // if(item.postfix.indexOf('image') > -1){
        this.$set(this.arrImgs, i, item.path)
        // }
      })
      this.curIndex = index
      this.showGallary = true
    },
    change(val) {
      let that = this;
      let Orientation = '';
      let mess = val.target.files;
      var files = Array.prototype.slice.call(mess);
      if (files.length + this.fileList.length > 9) {
        util.showToast('最多只可上传9张图片')
        return false;
      }
      util.showLoading()
      files.forEach(function (file, i) {
        if (!/\/(?:jpeg|png|gif)/i.test(file.type)) return;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, 'Orientation');
        });
        var reader = new FileReader();
        reader.onload = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          // 如果图片大小小于1000kb，则直接上传
          if (result.length <= that.maxsize) {
            img = null;
            that.upload(result, file.type, file.name);
            return;
          }
          //      图片加载完毕之后进行压缩，然后上传
          if (img.complete) {
            callback();
          } else {
            img.onload = callback;
          }
          function callback() {
            var data = that.compress(img, Orientation);
            that.upload(data, file.type, file.name);
            img = null;
          }
        };
        reader.readAsDataURL(file);
      })
    },
    compress(img, Orientation) {
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio;
      if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 如果图片像素大于100万则使用瓦片绘制
      var count;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6://需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8://需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3://需要180度旋转
            this.rotateImg(img, 'right', canvas);//转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      // 进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.6);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + '%');
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 图片上传，将base64的图片转成二进制对象，塞进formdata上传
    upload(basestr, type, name) {
      console.log(name)
      this.resetSign()
      let self = this;
      var text = window.atob(basestr.split(',')[1]);
      var buffer = new Uint8Array(text.length);
      for (var i = 0; i < text.length; i++) {
        buffer[i] = text.charCodeAt(i);
      }
      var blob = this.getBlob([buffer], type);
      var formdata = new FormData();
      console.log(blob)
      formdata.append('files', blob, '1.jpg');// 传文件
      formdata.append('target', self.targetId);
      formdata.append('moduleCode', "FX");
      formdata.append('platform', "SaasMobile");
      formdata.append('timestamp', self.timemap);
      formdata.append('sign', self.hex_md5_return);
      formdata.append('companyId', self.common.marketInfo.cityId);
      util.showLoading('上传中...')
      fetch(self.url, {
        method: 'post',
        body: formdata,
        headers: self.headers
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.code == 1000) {
          util.hideLoading()
          this.fileList.push({
            id: res.data[0].id,
            path: res.data[0].url
          })
        } else {
          util.hideLoading()
        }
      })
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = step * 90 * Math.PI / 180;
      let ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    getBlob(buffer, format) {
      try {
        return new Blob(buffer, { type: format });
      } catch (e) {
        var bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)();
        buffer.forEach(function (buf) {
          bb.append(buf);
        });
        return bb.getBlob(format);
      }
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    selectRepairType(item) {
      this.postInfo.repairType = item.text
      this.postInfo.repairTypeId = item.id
      this.border = true
      // this.$refs.personWrap.style.height = 0;
    },
    handleConfirm() {
      this.popupVisible = false
      let value = this.$refs.picker.getValues()[0];
      if (this.selectType == 'repairType') {
        this.postInfo.repairType = value
        this.border = true
        // 物业报修
        if (this.repairSelectType == 1) {
          this.repairTypeData_1.forEach(item => {
            if (item.text == value) {
              this.postInfo.repairTypeId = item.id
            }
          })
        } else {//投诉建议
          this.repairTypeData_2.forEach(item => {
            if (item.text == value) {
              this.postInfo.repairTypeId = item.id
            }
          })
        }
        // this.$refs.personWrap.style.height = 0;
      } else if (this.selectType == 'projectType') {
        this.spaceRelBeans.subProjectName = value
        for (let i = 0; i < this.projectType.length; i++) {
          if (this.projectType[i].text == value) {
            this.spaceRelBeans.subProjectId = this.projectType[i].id
            this.spaceRelBeans.projectId = this.projectType[i].projectId
          }
        }
        console.log(this.spaceRelBeans)
      }else if(this.selectType =='selectmarket'){
        for(var i=0;i<this.marketList.length;i++){
           if(this.marketList[i].marketName ==value){
              this.localMarkInfo = this.marketList[i];
              this.spaceRelBeans.subProjectId =this.localMarkInfo.id
              this.spaceRelBeans.subProjectName = this.localMarkInfo.marketName

           }
        }

      }

    },
    getData() {
      let that = this;
      let params = {
        companyId: this.common.userTenantInfo.companyId
      };
      util.showLoading("加载中...");
      getStoreList(params).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.res && res.res.code == 10000 && res.body && res.body.storeList) {
          that.fangList = res.body.storeList || [];
          let fl = res.body.storeList || []
          if (fl.length > 0) {
            that.selectItemArrStr = fl[0].storeName
            this.sureSelectItemList.push(fl[0].spaceId)
            this.selectItemArr.push(fl[0])
          }
        }
      });
    },
    cancelFang() {
      this.popupVisible_fang = false;
      this.selectItemList = [].concat(this.sureSelectItemList)
      this.selectItemArr_var = [].concat(this.selectItemArr)
      this.selectItemArrStr_var = this.selectItemArrStr
    },
    sureFang() {
      this.popupVisible_fang = false;
      this.sureSelectItemList = [].concat(this.selectItemList)
      this.selectItemArr = [].concat(this.selectItemArr_var)
      this.selectItemArrStr = this.selectItemArrStr_var
    },
    selectFang() {
      this.popupVisible_fang = true;
      this.selectItemList = [].concat(this.sureSelectItemList)
      this.selectItemArr_var = [].concat(this.selectItemArr)
      this.selectItemArrStr_var = this.selectItemArrStr
    },
    selectFangItem(item) {
      if (this.selectItemList.indexOf(item.spaceId) != -1) {
        let index = this.selectItemList.indexOf(item.spaceId)
        this.selectItemList.splice(index, 1)
        this.selectItemArr_var.splice(index, 1)
      } else {
        this.selectItemList.push(item.spaceId)
        this.selectItemArr_var.push(item)
      }
      let arr = []
      for (let i = 0; i < this.selectItemArr_var.length; i++) {
        arr.push(this.selectItemArr_var[i].storeName)
      }
      this.selectItemArrStr_var = arr.join(',')
    },
    select(type) {
      this.popupVisible = true;
      this.selectType = type
      if (type == 'repairType') {
        if (this.repairSelectType == 1) {
          this.dataList = this.repairTypeList_1;
        } else {
          this.dataList = this.repairTypeList_2;
        }
      } else if (type == 'projectType') {
        this.dataList = this.projectTypeList;
      }
    },
    selectmarket(){
       this.popupVisible = true;
       this.selectType = "selectmarket"
       this.dataList = this.marketTypeList
    },

    details(item) {
      this.$router.push(`/comReportingDetails?id=${item.localId}&contNo=${item.contNo}`);
    },
    submit() {
      if (this.common.userTenantInfo.userName) {
        this.postInfo.lesseeName = this.common.userTenantInfo.company
        this.postInfo.lesseeId = this.common.userTenantInfo.companyId
      }
      this.postInfo.thirdId = this.userId
      this.postInfo.platform = "RST"

      this.postInfo.companyId =  this.common.marketInfo.cityId//this.common.userInfo.cityId
      this.postInfo.url = "/property/rstRepair/createOrUpdateRepair"
      if (this.common.userTenantInfo.userName && this.fangList.length) {
        this.postInfo.publicArea = 2
        let arr = []
        for (let i = 0; i < this.selectItemArr.length; i++) {
          arr.push({
            id: this.selectItemArr[i].comId, //	公司id
            companyId: this.selectItemArr[i].comId, //公司id
            projectId: this.selectItemArr[i].mallId, //	项目id
            subProjectId:this.localMarkInfo ? this.localMarkInfo.id :this.common.marketInfo.id, //	子项目id
            buildId: this.selectItemArr[i].buildId, //楼宇id
            spaceId: this.selectItemArr[i].spaceId ? this.selectItemArr[i].spaceId : '', //房源id
            spaceName: this.selectItemArr[i].storeName, //房源名
            buildName: this.selectItemArr[i].buildName, //
            floorName: this.selectItemArr[i].floorName, //楼层名称
            floorId: this.selectItemArr[i].floorId, //楼层id
            maxArea: 0, //最大面积
            "icon": 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2843832834,3279034472&fm=26&gp=0.jpg'
          })
        }
        this.postInfo.rprRepairOrderSpaceRelBeans = arr
      } else {
        this.postInfo.publicArea = 1
        this.postInfo.rprRepairOrderSpaceRelBeans = [this.spaceRelBeans]
      }
      if (this.postInfo.repairType == '') {
        util.showToast('类型不能为空')
        return;
      }
      if (this.expectTime == '') {
        util.showToast('上门时间不能为空')
        return;
      }
      this.postInfo.expectTime = this.expectTime.replace(/-/g, '.') + ':00'

      if (this.postInfo.rprRepairOrderSpaceRelBeans.length == 0) {
        util.showToast('所属项目不能为空')
        return;
      }
      if (this.postInfo.promoter == '') {
        util.showToast('报修人不能为空')
        return;
      }
      if (this.postInfo.promoterPhoneNo == '') {
        util.showToast('报修人电话不能为空')
        return;
      }
      // if (this.postInfo.address == '') {
      //   util.showToast('提报地点不能为空')
      //   return;
      // }
      if (this.postInfo.remark == '') {
        util.showToast('问题描述不能为空')
        return;
      }
      util.showLoading("正在提交...");
      callSpaceUp(this.postInfo).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.res.code == 10000) {
          let id = res.body.data.id
          this.changeTarget(id)
          this.$router.replace(`/sublimeSuccess?id=${id}`);
        }
      });
    },
    getSubProjectList() {
      let parmes = {
        thirdId: this.userId,
        platform: "RST",
        companyId: this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '',
        url: "/property/rstRepair/getSubProjectList"
      }
      callSpaceUp(parmes).then(res => {
        console.log(res);
        if (res.res.code == 10000) {
          this.projectType = res.body.data
          var arr = []
          for (let i = 0; i < res.body.data.length; i++) {
            arr.push(res.body.data[i].subProjectName)
          }
          this.projectTypeList = [{
            flex: 1,
            values: arr,
            className: 'slot1',
            textAlign: 'center'
          }]
          console.log(this.projectTypeList);
        }
      });
    },
    getRepairType() {
      let parmes = {
        companyId: this.common.marketInfo.cityId,
        url: "/property/rstRepair/queryFirstRepairType"
      }
      callSpaceUp(parmes).then(res => {
        console.log(res)
        this.showPage = true
        if (res.res.code == 10000) {
          let repairType = res.body.data || []
          console.log("in repairType ==== " + JSON.stringify(repairType))
          let arr_1 = [], arr_2 = [], repairTypeData_1 = [], repairTypeData_2 = [];
          // 报修类型数据 type = 1 或者3  //投诉建议数据 type = 2

          repairType.forEach(item => {
            if (item.type == 1 || item.type == 3 ) {
              arr_1.push(item.text)
              repairTypeData_1.push(item)
            } else {
              arr_2.push(item.text)
              repairTypeData_2.push(item)
            }
          })
          this.repairTypeData_1 = repairTypeData_1;
          this.repairTypeData_2 = repairTypeData_2;
          this.repairTypeList_1 = [{
            flex: 1,
            values: arr_1,
            className: 'slot1',
            textAlign: 'center'
          }]
          this.repairTypeList_2 = [{
            flex: 1,
            values: arr_2,
            className: 'slot1',
            textAlign: 'center'
          }]
        }
      });
    },
    personScroll() {
      // 默认有六个li子元素，每个子元素的宽度为120px
      let width = 10 * 120;
      if (!this.$refs.personTab) {
        return;
      }
      this.$refs.personTab.style.width = width + "px";
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.personWrap, {
            startX: 0,
            click: true,
            scrollX: true,
            // 忽略竖直方向的滚动
            scrollY: false,
            eventPassthrough: "vertical"
          });
        } else {
          this.scroll.refresh();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.type_box {
  background: #fff;
  padding: 42px 0;
  .flex();
  justify-content: center;
  .type_box_item {
    .flex();
    width: 208px;
    height: 76px;
    justify-content: center;
    align-items: center;
    margin: 0 14px;
    border-radius: 8px;
    border: 2px solid #eaeaea;
    img {
      display: block;
      width: 32px;
      height: 32px;
      margin-right: 12px;
    }
    p {
      font-size: 30px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .cur {
    border: 2px solid #1740da;
  }
}
.comReport {
  width: 100%;
  overflow-x: hidden;
  background: rgba(237, 237, 237, 1);
  .module {
    margin-bottom: 14px;
    .selectBottom {
      height: 80px;
      width: 100%;
      background: #fff;
      border-bottom: 1px solid #eaeaea;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .selectTab {
        display: flex;
        align-items: center;
        padding: 0 20px;
      }
      .tag {
        min-width: 140px;
        max-width: 148px;
        margin-right: 10px;
        height: 48px;
        padding: 0 8px;
        background: rgba(243, 245, 253, 1);
        border-radius: 4px;
        // border: 1px solid rgba(150,170,240,1);
        .border(rgba(150,170,240,1));
        font-size: 24px;
        box-sizing: border-box;
        color: rgba(23, 64, 218, 1);
        text-align: center;
        line-height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .titleOther {
    height: 100px;
    background-color: #fff;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .Must {
    font-size: 28px;
    color: rgba(252, 63, 86, 1);
    display: inline-block;
    line-height: 100px;
  }
  .Mustno {
    color: #fff;
  }
  .titleOther_tips {
    color: #9d9d9d;
    font-size: 28px;
  }
  .textarea {
    width: 100%;
    height: 182px;
    padding: 0 40px;
    box-sizing: border-box;
    font-size: 28px;
    color: #333333;
  }
  .pic {
    flex: 1;
    background: #fff;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    .addPic {
      width: 160px;
      height: 160px;
      background: rgba(244, 244, 244, 1);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-bottom: 20px;
      margin-right: 20px;
      .video_icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 68px;
        height: 68px;
      }
      .video {
        width: 160px;
        height: 160px;
      }
      .addImg {
        width: 28px;
        height: 28px;
      }
      .file {
        position: absolute;
        width: 160px;
        height: 160px;
        opacity: 0;
      }
      .deleteFile {
        position: absolute;
        right: -25px;
        top: -25px;
        width: 50px;
        height: 50px;
      }
    }
  }
  .tips {
    color: #fc3f56;
    font-size: 20px;
    line-height: 30px;
    padding: 0 30px 20px;
    background: #fff;
  }
  .btnWrap_h {
    width: 100%;
    height: 108px;
  }

  .bottomBtn_wrap {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 108px;
    background: #fff;
    .btn {
      width: 694px;
      height: 76px;
      background: rgba(218, 218, 218, 1);
      border-radius: 4px;
      margin: 16px 28px;
      font-size: 32px;

      text-align: center;
      line-height: 76px;
      color: #fff;
    }
    .bottomBtn {
      background: #1740da;
      color: #fff;
    }
  }

  .inpBox {
    width: 100%;
    height: 100px;
    border-bottom: 1px solid #eaeaea;
    background: #fff;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;
    z-index: 99;
    .Must {
      font-size: 28px;

      color: rgba(252, 63, 86, 1);
      display: inline-block;
      line-height: 100px;
    }
    .Mustno {
      color: #fff;
    }
    .title {
      width: 120px;
      text-align: left;
      font-size: 28px;

      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      margin-left: 4px;
    }
    .inpWrap {
      flex: 1;
      padding-left: 60px;
      display: flex;
      .inp {
        flex: 1;
        font-size: 28px;

        color: rgba(51, 51, 51, 1);
      }
      .selectValue_p {
        color: #c9c9c9;
      }
    }
    .rightIcon {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .inpBox_noBorder {
    border-bottom: none;
  }
  .ant-upload {
    width: 160px;
    height: 160px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    margin-right: 20px;
  }
}
.ant-upload-btn {
  width: 170px !important;
  height: 170px !important;
  background: red !important;
}
// 选择房源
.fang {
  width: 750px;
  height: 608px;
  background: #fff;
  .fang_title {
    display: flex;
    align-items: center;
    height: 80px;
    .fang_title_1,
    .fang_title_3 {
      padding: 20px 28px;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      text-align: center;
    }
    .fang_title_2 {
      flex: 1;
      height: 44px;
      font-size: 32px;
      color: rgba(51, 51, 51, 1);
      line-height: 44px;
      text-align: center;
    }
    .fang_title_3 {
      color: #1740da;
    }
  }
  .fangCon {
    height: 520px;
    overflow-y: scroll;
    padding-top: 24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    .fangCon_item {
      height: 80px;
      display: flex;
      align-items: center;
      padding-left: 28px;
      box-sizing: border-box;
      .fangCon_item_1 {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        border: 2px solid rgba(218, 218, 218, 1);
        box-sizing: border-box;
        border-radius: 50%;
      }
      .fangCon_item_1_img {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        border-radius: 50%;
      }
      .fangCon_item_2 {
        flex: 1;
        height: 44px;
        font-size: 32px;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
      }
    }
  }
}
.add_icon {
  font-size: 50px;
  color: #999;
}
</style>
